import * as semver from 'semver'
import types from '@/utils/types'

const navigation_version = '10.13.0'

const common = {
  state: {
    deviceType: '',
    browserType: ''
  },
  mutations: {
    setDeviceType: (state, type) => {
      if (Object.prototype.hasOwnProperty.call(types.DeviceType, type)) {
        throw new Error('Device Type이 맞지 않습니다!')
      }

      state.deviceType = type
    },

    setBrowserType: (state, type) => {
      if (Object.prototype.hasOwnProperty.call(types.BrowserType, type)) {
        throw new Error('Browser Type이 맞지 않습니다!')
      }

      state.browserType = type
    },
    hideVirtualKeyboard: () => {
      if (
        document.activeElement &&
        document.activeElement.blur &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur()
      }
    },
    showNavigationBar: (state, payload) => {
      if (semver.gte(payload.appVersion, navigation_version)) {
        // 버전 이상이면
        if (state.deviceType === types.DeviceType.android) {
          return MarketJavaScriptInterface.showTitleBar()
        }

        if (window.webkit === undefined) return null

        if (window.webkit.messageHandlers !== undefined) {
          return window.webkit.messageHandlers.showTitleBar.postMessage('')
        }
      } else {
        // 버전보다 낮으면
        if (state.deviceType === types.DeviceType.android) {
          return MarketOrdJavaScriptInterface.showToolBar()
        }

        if (window.webkit === undefined) return null

        if (window.webkit.messageHandlers !== undefined) {
          return window.webkit.messageHandlers.visible.postMessage('show')
        }
      }
    },
    hideNavigationBar: (state, payload) => {
      if (semver.gte(payload.appVersion, navigation_version)) {
        // 버전 이상이면
        if (state.deviceType === types.DeviceType.android) {
          return MarketJavaScriptInterface.hideTitleBar()
        }

        if (window.webkit === undefined) return null

        if (window.webkit.messageHandlers !== undefined) {
          return window.webkit.messageHandlers.hideTitleBar.postMessage('')
        }
      } else {
        // 버전보다 낮으면
        if (state.deviceType === types.DeviceType.android) {
          return MarketOrdJavaScriptInterface.hideToolBar()
        }

        if (window.webkit === undefined) return null

        if (window.webkit.messageHandlers !== undefined) {
          return window.webkit.messageHandlers.visible.postMessage('hide')
        }
      }
    }
  },
  getters: {
    isAndroid: state => state.deviceType === types.DeviceType.android,
    isSafari: state => state.browserType === types.BrowserType.safari,
    isIos: state => state.deviceType === types.DeviceType.ios
  },
  actions: {
    initUserAgent: ({
      commit
    }) => {
      const {
        userAgent
      } = navigator

      const isAndroid = /Android/i.test(userAgent)
      const isSafari = /Safari/i.test(userAgent)

      commit('setDeviceType', isAndroid ? 'Android' : 'Ios')
      commit('setBrowserType', isSafari ? 'Safari' : 'Chrome')
    }
  }
}

export default common
